namespace RioERP.Orders {
    export interface FranchiseePayoutRequest extends Serenity.ServiceRequest {
        rowIds?: string;
    }
}
